import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/banner.jpg';
import _imports_1 from './img/scope/医院.svg';
import _imports_2 from './img/scope/门诊.svg';
import _imports_3 from './img/scope/中医.svg';
import _imports_4 from './img/scope/专科.svg';
import _imports_5 from './img/scope/个人定制.svg';
import _imports_6 from './img/在线挂号.png';
import _imports_7 from './img/三方合作.png';
import _imports_8 from './img/解决方案.png';
import _imports_9 from './img/排队.png';
import _imports_10 from './img/advantages/操作.svg';
import _imports_11 from './img/advantages/售后.svg';
import _imports_12 from './img/advantages/升级.svg';
const _withScopeId = n => (_pushScopeId("data-v-02c2a793"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cloud_wrap"
};
const _hoisted_2 = {
  class: "banner_wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "banner_text"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, "保达云诊所系统", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode("客户管理、线上营销、经营管理、智能信息化"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("为门诊-诊所医疗机构提供一站式信息化解决方案")], -1));
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"scope_wrap container\" data-v-02c2a793><div class=\"title\" data-v-02c2a793>保达云诊所系统</div><div class=\"desc\" data-v-02c2a793>全流程经营管理覆盖医疗机构</div><div class=\"scope_content\" data-v-02c2a793><div class=\"list\" data-v-02c2a793><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_1 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>卫生室/医务室</div><div class=\"item_desc\" data-v-02c2a793>以病人信息化为核心，提供诊前-诊中-诊后一站式无纸化办公诊疗服务</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_2 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>诊所/个人诊所</div><div class=\"item_desc\" data-v-02c2a793>以病人信息化为核心，提供简化管理-便捷开方的无纸化管理模式</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_3 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>中医诊所/中医馆</div><div class=\"item_desc\" data-v-02c2a793>以病人信息为核心，打造开处方-理疗管理-客户跟踪-会员管理等智能信息化</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_4 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>专科/综合门诊部</div><div class=\"item_desc\" data-v-02c2a793>为医疗机构实现内部信息化管理，打造闭环链接的一站式信息化管理服务</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_5 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>定制化服务</div><div class=\"item_desc\" data-v-02c2a793>以数据作为核心，提供个性化定制一站式信息管理解决方案，高端医疗管理软件解决方案</div></div></div></div></div></div>", 1);
const _hoisted_8 = {
  class: "menu_wrap"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "营销经营管理一体化", -1));
const _hoisted_10 = {
  class: "menu_content container"
};
const _hoisted_11 = ["data-id"];
const _hoisted_12 = ["data-id"];
const _hoisted_13 = ["data-id"];
const _hoisted_14 = {
  class: "bottom"
};
const _hoisted_15 = {
  class: "bottom_content"
};
const _hoisted_16 = {
  class: "content"
};
const _hoisted_17 = ["data-id"];
const _hoisted_18 = ["data-id"];
const _hoisted_19 = ["src", "data-id"];
const _hoisted_20 = ["data-id"];
const _hoisted_21 = ["data-id"];
const _hoisted_22 = ["data-id"];
const _hoisted_23 = {
  class: "second_img"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<div class=\"registered_wrap\" data-v-02c2a793><div class=\"registered_inner container\" data-v-02c2a793><div class=\"img_wrap\" data-v-02c2a793><img src=\"" + _imports_6 + "\" alt=\"\" data-v-02c2a793></div><div class=\"content_wrap\" data-v-02c2a793><div class=\"bigTitle\" data-v-02c2a793>在线预约挂号</div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>挂号渠道：</div><div class=\"typeText\" data-v-02c2a793>微信预约挂号接口，实现线上线下共用号源池</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>挂号类型：</div><div class=\"typeText\" data-v-02c2a793>医生排班以及治疗项目变更数据互通</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>挂号相关功能：</div><div class=\"typeText\" data-v-02c2a793>挂号相关的短信服务对接以及问诊相关推送</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>微会员查询：</div><div class=\"typeText\" data-v-02c2a793>可直接在微信公众号查询充值卡使用记录、套餐记录、积分</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>信息推送：</div><div class=\"typeText\" data-v-02c2a793>消费记录、充值卡、挂号信息等信息推送功能</div></div></div></div></div><div class=\"thirdPartner_wrap\" data-v-02c2a793><div class=\"thirdPartner_inner container\" data-v-02c2a793><div class=\"content_wrap\" data-v-02c2a793><div class=\"bigTitle\" data-v-02c2a793>链接第三方合作伙伴</div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>量化设备接口</div><div class=\"typeText\" data-v-02c2a793>各种中医量化诊疗设备接口对接，智能颗粒调配机设备对接</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>移动支付接口</div><div class=\"typeText\" data-v-02c2a793>实现微信、支付宝等多种支付方式接口对接</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>卫健局监管平台接口</div><div class=\"typeText\" data-v-02c2a793>可对接各地监管平台接口，有现成的监管平台接口广州、深圳。</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>医保社保接口</div><div class=\"typeText\" data-v-02c2a793>对接全国各地医保社保接口，有现成广州、佛山、珠海、深圳等多地医保接口</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>其他系统接口</div><div class=\"typeText\" data-v-02c2a793>可对接其他系统接口对接，如美团、会员系统、校园一卡通等</div></div></div><div class=\"img_wrap\" data-v-02c2a793><img src=\"" + _imports_7 + "\" alt=\"\" data-v-02c2a793></div></div></div><div class=\"chain_wrap\" data-v-02c2a793><div class=\"chain_inner container\" data-v-02c2a793><div class=\"img_wrap\" data-v-02c2a793><img src=\"" + _imports_8 + "\" alt=\"\" data-v-02c2a793></div><div class=\"content_wrap\" data-v-02c2a793><div class=\"bigTitle\" data-v-02c2a793>连锁门店管理解决方案</div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>集团化连锁门店管理</div><div class=\"typeText\" data-v-02c2a793>实现多门店管理维护机构的组织架构</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>患者会员管理</div><div class=\"typeText\" data-v-02c2a793>支持会员患者统一管理与数据共享，提升服务能力</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>连锁化数据报表经营管理</div><div class=\"typeText\" data-v-02c2a793>精准化医馆数据经营详情，收入、成本、利润、提成等核算方案</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>共享药房</div><div class=\"typeText\" data-v-02c2a793>实现共享药房，多门店处方流转到共享药房处，提供配送服务</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>处方病历共享</div><div class=\"typeText\" data-v-02c2a793>连锁化可实现处方病历共享，便于客户跨店看诊</div></div></div></div></div><div class=\"queuing_wrap\" data-v-02c2a793><div class=\"queuing_inner container\" data-v-02c2a793><div class=\"content_wrap\" data-v-02c2a793><div class=\"bigTitle\" data-v-02c2a793>排队叫号解决方案</div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>医疗机构大厅</div><div class=\"typeText\" data-v-02c2a793>门诊大厅是医院人流最密集的地方，分流门诊大厅患者到各个科室或病房，及时获取就诊流程提高工作效率</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>候诊区、门诊、护士站区域</div><div class=\"typeText\" data-v-02c2a793>患者可清晰看到队列情况，预计自己等候的时间，屏幕还可以分屏显示宣传视频或娱乐节目，让整个就诊区有序安静</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>检查室、排队取药窗口</div><div class=\"typeText\" data-v-02c2a793>建立可视化排队叫号显示系统，明示队列详细情况，让患者了解自己排队的进度情况，安心等候</div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>病人活动区域、人流密集区</div><div class=\"typeText\" data-v-02c2a793>把医院长期积累的治疗方式和康复措施，通过终端播放给病人，同时可用来宣传医院信息、专家介绍、温馨提示语等 </div></div><div class=\"type_wrap\" data-v-02c2a793><div class=\"typeName\" data-v-02c2a793>排队叫号硬件设备</div><div class=\"typeText\" data-v-02c2a793>提供候诊厅、医生诊室门口等多地方的硬件设备，可方便展示排队信息、医生介绍等</div></div></div><div class=\"img_wrap\" data-v-02c2a793><img src=\"" + _imports_9 + "\" alt=\"\" data-v-02c2a793></div></div></div><div class=\"advantages_wrap container\" data-v-02c2a793><div class=\"title\" data-v-02c2a793>保达云诊所系统亮点和优点</div><div class=\"list\" data-v-02c2a793><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_10 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>操作使用简单方便</div><div class=\"item_desc\" data-v-02c2a793>采用云存储服务，随时随地登陆网站即刻使用。植入移动互联网管理模式与链接第三方平台接口；操作简单、界面美观，无任何电脑知识也一看即会。</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_11 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>售后服务升级便捷</div><div class=\"item_desc\" data-v-02c2a793>便捷：采用B/S结构，无客户端，电脑中毒和软件数据与数据库无关；维护方便、低成本，时间短，高效售后：出现任何系统问题，实现网络检测与维护修改。</div></div></div><div class=\"item\" data-v-02c2a793><img class=\"item_img\" src=\"" + _imports_12 + "\" alt=\"\" data-v-02c2a793><div class=\"item_content\" data-v-02c2a793><div class=\"item_title\" data-v-02c2a793>终身软件升级等服务</div><div class=\"item_desc\" data-v-02c2a793>安全性高成本低：云存储服务，电脑硬盘损坏、中毒等，数据也不会丢失。对有关键数据都进行不可逆的加密措施，有效保障数据安全；低成本：采用浏览器访问，不需要部署，价格便宜。</div></div></div></div></div>", 5);
import { ref, computed } from 'vue';
import dialogCustomer from '@/components/Customer';
import Form from '@/components/Form';
export default {
  __name: 'index',
  setup(__props) {
    const form = ref(null);
    const customer = ref(null);
    const fist_menu = ref(1);
    const second_menu = ref(1);
    const third_menu = computed(() => {
      return second_menu_option.value.filter(v => second_menu.value == v.id)[0].pic;
    });
    const menu_option = ref([{
      id: 1,
      title: '患者管理',
      desc: '客户信息归档化',
      child: [{
        id: 1,
        icon: require('@/views/Cloud/img/menu/客户管理.svg'),
        title: '客户基本信息管理',
        desc: '采用云端管理病人的基本信息，多字段满足对客户建档的需求，可多维度通过关键词搜索、查询患者的基本信息',
        pic: require('@/views/Cloud/img/menu/yunzhensuo1.png')
      }, {
        id: 2,
        icon: require('@/views/Cloud/img/menu/挂号.svg'),
        title: '挂号管理',
        desc: '可通过线下挂号、电话预约挂号、微信预约挂号等多种模式挂号，便捷查询每天挂号看诊量',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }, {
        id: 3,
        icon: require('@/views/Cloud/img/menu/标签.svg'),
        title: '患者标签化管理',
        desc: '慢病、病人来源、各种类型病种标签化管理，针对不同类型不同标签的客户提供有效诊疗服务，便于做标签化客户营销',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }]
    }, {
      id: 2,
      title: '医生看诊',
      desc: '历史病历处方一键查询',
      child: [{
        id: 1,
        icon: require('@/views/Cloud/img/menu/客户管理.svg'),
        title: '历史病历处方管理',
        desc: '医生可快速查询患者的历史病历和处方，根据情况可快速调用历史病历历史处方，根据病状增减用量',
        pic: require('@/views/Cloud/img/menu/yunzhensuo2.png')
      }, {
        id: 2,
        icon: require('@/views/Cloud/img/menu/挂号.svg'),
        title: '协定处方管理',
        desc: '医生可以管理一些经方验方，方便管理一些方剂内容，科学化减少医生对方剂的记忆，让用方更保障更快捷',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }, {
        id: 3,
        icon: require('@/views/Cloud/img/menu/标签.svg'),
        title: '病历模板管理',
        desc: '医生可以管理一些常用病历，系统支持快速选用一些基本病历用语，减轻医生写病历的负担',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }]
    }, {
      id: 3,
      title: '收费/打印管理',
      desc: '多方式收费更便捷',
      child: [{
        id: 1,
        icon: require('@/views/Cloud/img/menu/客户管理.svg'),
        title: '自动划价收费',
        desc: '系统支持微信、支付宝、收钱吧等多种移动支付收费方式，成功对接移动支付接口，收费更便捷',
        pic: require('@/views/Cloud/img/menu/yunzhensuo3.png')
      }, {
        id: 2,
        icon: require('@/views/Cloud/img/menu/挂号.svg'),
        title: '医保收费',
        desc: '对接医保可实现医保统筹报销功能，可实现医保直接收费功能',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }, {
        id: 3,
        icon: require('@/views/Cloud/img/menu/标签.svg'),
        title: '打印管理',
        desc: '系统支持打印处方、病历、注射单、收费小票、挂号小票、收费清单、全国医疗票据等，操作简单便捷',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }]
    }, {
      id: 4,
      title: '会员管理',
      desc: '营销促销吸引客户',
      child: [{
        id: 1,
        icon: require('@/views/Cloud/img/menu/客户管理.svg'),
        title: '会员打折充值',
        desc: '系统可以设置不同会员等级，通过会员等级可以实现不同折扣优惠，门店可以提供充值服务，充值多少送多少优惠活动',
        pic: require('@/views/Cloud/img/menu/yunzhensuo4.png')
      }, {
        id: 2,
        icon: require('@/views/Cloud/img/menu/挂号.svg'),
        title: '会员套餐',
        desc: '可设置不同的会员套餐，比如卡次、不同项目套餐等营销模式，方便门店引流做活动',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }, {
        id: 3,
        icon: require('@/views/Cloud/img/menu/标签.svg'),
        title: '会员统计',
        desc: '针对会员的所有消费以及会员的相关使用充值退费都有记录查询，方便统计会员客户数据',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }]
    }, {
      id: 5,
      title: '药房进销存管理',
      desc: '药品管理更方便',
      child: [{
        id: 1,
        icon: require('@/views/Cloud/img/menu/客户管理.svg'),
        title: '药房管理',
        desc: '系统实现数据互传药房发药、退药、作废等管理，实现数据实时准确，发药退药一键处理',
        pic: require('@/views/Cloud/img/menu/yunzhensuo5.png')
      }, {
        id: 2,
        icon: require('@/views/Cloud/img/menu/挂号.svg'),
        title: '进销存管理',
        desc: '药品出库、药品入库记录可清晰查询，可以实现报损出库、领料出库、退货出库等管理，对药品库存盘点、库存报警等管理',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }, {
        id: 3,
        icon: require('@/views/Cloud/img/menu/标签.svg'),
        title: '药品智能采购',
        desc: '系统可根据库存预警、高毛利、高流通等多维度自动生成采购单，采购确认后可一键入库',
        pic: require('@/views/Cloud/img/menu/位图1.png')
      }]
    }]);
    const fist_menu_option = computed(() => menu_option.value.map((v, i) => {
      return {
        id: v.id,
        title: v.title,
        desc: v.desc
      };
    }));
    const second_menu_option = computed(() => {
      return menu_option.value.filter(v => v.id == fist_menu.value)[0].child;
    });
    const handleFistMenu = function (event) {
      let {
        id
      } = event.target.dataset;
      fist_menu.value = id;
      second_menu.value = 1;
      // console.log(fist_menu.value)
    };

    const handleSecondMenu = function (event) {
      let {
        id
      } = event.target.dataset;
      console.log(id);
      second_menu.value = id;
      console.log(second_menu.value);
    };
    const handleOpen = function () {
      // customer.value.openDialog()
      form.value.openForm();
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_el_button, {
        class: "free_btn",
        onClick: handleOpen
      }, {
        default: _withCtx(() => [_createTextVNode("立即试用")]),
        _: 1
      })])]), _hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "top",
        onClick: handleFistMenu
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fist_menu_option), (v, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: v.id,
          class: _normalizeClass(fist_menu.value == v.id ? 'top_item active' : 'top_item'),
          "data-id": v.id
        }, [_createElementVNode("div", {
          class: "title",
          "data-id": v.id
        }, _toDisplayString(v.title), 9, _hoisted_12), _createElementVNode("div", {
          class: "desc",
          "data-id": v.id
        }, _toDisplayString(v.desc), 9, _hoisted_13)], 10, _hoisted_11);
      }), 128))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
        class: "second_menu",
        onClick: handleSecondMenu
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(second_menu_option), (v, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: "v.id",
          class: _normalizeClass(second_menu.value == v.id ? 'item active' : 'item'),
          "data-id": v.id
        }, [_createElementVNode("div", {
          class: "item_img",
          "data-id": v.id
        }, [_createElementVNode("img", {
          src: v.icon,
          alt: "",
          "data-id": v.id
        }, null, 8, _hoisted_19)], 8, _hoisted_18), _createElementVNode("div", {
          class: "item_text",
          "data-id": v.id
        }, [_createElementVNode("div", {
          class: "title",
          "data-id": v.id
        }, _toDisplayString(v.title), 9, _hoisted_21), _createElementVNode("div", {
          class: "desc",
          "data-id": v.id
        }, _toDisplayString(v.desc), 9, _hoisted_22)], 8, _hoisted_20)], 10, _hoisted_17);
      }), 128))]), _createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
        src: _unref(third_menu),
        alt: ""
      }, null, 8, _hoisted_24)])]), _createElementVNode("div", {
        class: "button",
        onClick: handleOpen
      }, "立即试用")])])])]), _hoisted_25, _createVNode(_unref(dialogCustomer), {
        ref_key: "customer",
        ref: customer
      }, null, 512), _createVNode(_unref(Form), {
        ref_key: "form",
        ref: form
      }, null, 512)]);
    };
  }
};